<app-dashboard>
  <div class="w-full flex flex-col gap-[30px] justify-center p-[20px]">
    <div class="w-full flex justify-end">
      <app-button
        [label]="'New Reward'"
        (onClick)="openModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
    <app-table
      [tableData]="tableData"
      [tableHeader]="tableHeader"
      (rowClick)="openDetailsModal($event)"
      [tableTitle]="'Transactions'"
      [loading]="fetchingData"
      [emptyState]="emptyTableState"
      [filterData]="filterData"
      (handleFilter)="applyFilter($event)"
      (handleSearch)="search($event)"
      [tableWidth]="' min-w-[990px]'"
      [toolbar]="{
        paginate: true,
        search: true,
        filter: true,
        addnew: false
      }"
      [paginationData]="{
        limit: limit,
        totalData: totalRewards
      }"
      (changeLimit)="changeLimit($event)"
    >
      <div class="flex justify-end items-center sm:w-full">
        <app-pagination
          *ngIf="!fetchingData && this.totalRewards > 0"
          [totalItems]="this.totalRewards"
          [(pageSize)]="this.limit"
          [(currentPage)]="this.page"
          (pageSizeChange)="this.refreshList()"
          (currentPageChange)="this.getRewards()"
        ></app-pagination>
      </div>
    </app-table>

  </div>
</app-dashboard>
<app-modal
  [isOpen]="modalOpen"
  (closeModalEvent)="closeModal()"
  [title]="'Create New Reward'"
  ><div class="w-full flex flex-col gap-[20px]">
    <div
      class="w-full flex {{
        createRewardPage == 1 ? 'justify-end' : 'justify-between'
      }}"
    >
      <div
        class="flex items-center {{
          createRewardPage == 1 ? 'hidden' : 'flex'
        }}"
      >
        <img src="../../../assets/icons/chevron-left1.svg" alt="" />
        <span
          class="text-[14px] text-slate-500 font-[600]"
          (click)="previousPage()"
          >Back</span
        >
      </div>
      <span class="text-slate-700 font-[700] text-[14px]"
        >{{ createRewardPage
        }}<span class="font-[500] text-slate-500 text-[12px]"
          >/{{ maxPages }}</span
        ></span
      >
    </div>
    <div *ngIf="createRewardPage == 1" class="w-full flex flex-col">
      <app-dropdown-search
        *ngIf="rewardTypes.length > 0"
        [label]="'Reward Types'"
        [items]="rewardTypes"
        (selectedItem)="onItemSelected($event)"
      ></app-dropdown-search>

      <div class="w-full grid grid-cols-2 gap-[20px]">
        <app-input
          [label]="'Reward Name'"
          [placeholder]="'Enter reward name'"
          (returnValue)="handleInput($event)"
          [title]="'name'"
        />
        <app-input
          [label]="'Minimum Balance Amount'"
          [placeholder]="'Enter minimum balance amount'"
          [title]="'minimumBalanceAmount'"
          (returnValue)="handleInput($event)"
        />
        <!-- <app-date-picker
          [label]="'Reward Expiry Date'"
          (returnValue)="setExpiry($event)"
        /> -->
      </div>

      <div class="w-full grid grid-cols-2 gap-[20px]">
        <app-input
          [label]="'Activation Minimum Count'"
          [placeholder]="'Enter activation minimum count'"
          [title]="'rewardActivationMinimumCount'"
          (returnValue)="handleInput($event)"
        />
        <app-input
          [label]="'Active Cycle Count'"
          [placeholder]="'Enter active cycle count'"
          [title]="'activeCycleCount'"
          (returnValue)="handleInput($event)"
        />
      </div>
      <div class="w-full grid grid-cols-2 gap-[20px]">
        <app-dropdown
          [label]="'Expiration Duration'"
          [placeholder]="'Enter expiration duration'"
          [title]="'rewardExpirationDuration'"
          [items]="durationOptions"
          (selectedValue)="handleInput($event)"
        />
        <app-input
          [label]="'Reward Expiry Date'"
          [placeholder]="'Enter expiry date'"
          [title]="'rewardExpiration'"
          (returnValue)="handleInput($event)"
        />
      </div>
      <app-dropdown
        [label]="'Activation Cycle Type'"
        [placeholder]="'Enter activation cycle count'"
        [title]="'activationCycleType'"
        [items]="durationOptions"
        (selectedValue)="handleInput($event)"
      />
      <app-text-area
        [label]="'Reward Usage Description'"
        [placeholder]="'Enter reward description'"
        [title]="'usageDescription'"
        (returnValue)="handleInput($event)"
      />
    </div>
    <div *ngIf="createRewardPage == 2" class="w-full flex flex-col gap-[6px]">
      <span>Reward Usage Format</span>
      <form>
        <div
          *ngFor="let format of newReward.rewardUsageFormat; let i = index"
          class="w-full flex gap-[20px]"
        >
          <div
            class="w-full flex flex-col sm:gap-[20px] gap-[0px] sm:grid sm:grid-cols-2"
          >
            <div class="flex flex-col gap-[6px]">
              <label class="font-[800] text-[14px] text-[#6B7280]" for="name"
                >Name</label
              >
              <input
                id="name"
                class="h-[52px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
                type="text"
                [(ngModel)]="format.name"
                name="name"
                placeholder="Enter first value"
              />
            </div>

            <div class="w-full flex-col flex gap-[6px]">
              <label
                class="font-[800] text-[14px] text-[#6B7280]"
                for="percentageUsage"
                >Percentage</label
              >
              <input
                id="percentageUsage"
                class="h-[52px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
                type="text"
                [(ngModel)]="format.percentageUsage"
                name="percentageUsage"
                placeholder="Enter second value"
              />
            </div>
          </div>

          <button type="button" class="text-[20px]" (click)="removeReward(i)">
            &times;
          </button>
        </div>

        <div class="w-full flex justify-end pe-[28px] mt-[10px]">
          <button type="button" (click)="addReward()">
            <img src="../../../assets/icons/add.png" alt="" />
          </button>
        </div>
      </form>
    </div>
    <div *ngIf="createRewardPage == 3" class="w-full flex flex-col gap-[6px]">
      <span>Task List</span>
      <form>
        <div
          *ngFor="let task of newReward.taskList; let i = index"
          class="flex items-start gap-[15px]"
        >
          <div class="sm:grid w-full sm:grid-cols-2 gap-[20px] flex flex-col">
            <div class="w-full flex flex-col gap-[5px]">
              <label class="font-[800] text-[14px] text-[#6B7280]" for="name"
                >Name</label
              >
              <input
                id="name"
                type="text"
                [(ngModel)]="task.name"
                class="h-[52px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
                name="name"
                placeholder="Enter first value"
              />
            </div>

            <div class="w-full flex flex-col gap-[5px]">
              <label
                class="font-[800] text-[14px] text-[#6B7280]"
                for="taskDescription"
                >Task Description</label
              >
              <input
                id="taskDescription"
                class="h-[52px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
                type="text"
                [(ngModel)]="task.taskDescription"
                name="taskDescription"
                placeholder="Enter second value"
              />
            </div>
          </div>

          <div class="w-fit flex flex-col gap-[5px]">
            <label
              class="font-[800] text-[14px] text-[#6B7280] flex flex-col items-center gap-[6px]"
            >
              Compulsory?
              <input
                class="w-[20px] h-[20px]"
                type="radio"
                [checked]="task.isCompulsory"
                (click)="toggleTaskState(i)"
              />
            </label>
          </div>

          <button type="button" (click)="removeTask(i)" class="text-[20px]">
            &times;
          </button>
        </div>

        <div class="w-full flex justify-end pe-[28px]">
          <button type="button" (click)="addTask()">
            <img src="../../../assets/icons/add.png" alt="" />
          </button>
        </div>
      </form>
    </div>
    <div class="w-full">
      <div class="w-full flex justify-end">
        <app-button
          [label]="createRewardPage < maxPages ? 'Next' : 'Submit'"
          [loading]="loading"
          (onClick)="createRewardPage < maxPages ? nextPage() : createReward()"
          [className]="
            'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
          "
        />
      </div>
    </div></div
></app-modal>
<app-side-modal
  [isOpen]="detailsModalOpen"
  (closeModalEvent)="closeDetailsModal()"
  [title]="'Reward Details'"
>
  <div class="w-full flex flex-col gap-[10px]">
    <div class="w-full flex flex-col gap-[2px] border-b pb-[10px]">
      <span class="text-[22px] font-[800] text-slate-800">{{
        singleReward?.name
      }}</span>
      <div class="flex items-center gap-[3px]">
        <img src="../../../assets/icons/clock-icon.svg" alt="" />
        <span class="text-[12px] font-[400] text-slate-400">{{
          singleReward?.createdAt
        }}</span>
      </div>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]">Reward Type:</span>
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.rewardType?.name
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]">Description:</span>
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.usageDescription
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Expiration Duration:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.rewardExpirationDuration
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]">Expiration:</span>
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.rewardExpiration
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Activation Cycle Type:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.activationCycleType
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Active Cycle Count:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.activeCycleCount
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Activation Minimum Count:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.rewardActivationMinimumCount
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Minimum Balance Amount:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.minimumBalanceAmount
      }}</span>
    </div>
    <div class="w-full flex items-center justify-between border-b pb-[5px]">
      <span class="text-[11px] text-[#6B7280] font-[500]"
        >Amount Per Count:</span
      >
      <span class="text-[13px] text-[#1F2937] font-[800]">{{
        singleReward?.rewardAmountPerCount
      }}</span>
    </div>
    <div class="w-full flex flex-col gap-[10px]">
      <span class="text-[16px] font-[600] text-slate-800"
        >Reward Usage Format</span
      >
      <div
        *ngFor="let format of singleReward?.rewardUsageFormat"
        class="w-full flex items-center justify-between border-b pb-[5px]"
      >
        <span class="text-[11px] text-[#6B7280] font-[500] capitalize">{{
          format?.name
        }}</span>
        <span class="text-[13px] text-[#1F2937] font-[800]">{{
          format?.percentageUsage
        }}</span>
      </div>
    </div>
    <div
      *ngIf="this.singleReward?.taskList.length > 0"
      class="w-full flex flex-col gap-[10px]"
    >
      <span class="text-[16px] font-[600] text-slate-800">Task List</span>
      <div
        *ngFor="let task of singleReward?.taskList"
        class="w-full flex items-center justify-between border-b pb-[5px]"
      >
        <div class="w-full flex flex-col">
          <span class="text-[11px] text-[#6B7280] font-[500] capitalize">{{
            task?.name
          }}</span>
          <span class="text-[10px] font-[400] text-[#6B7280]">{{
            task?.taskDescription
          }}</span>
        </div>
        <span class="text-[13px] text-[#1F2937] font-[800]">{{
          task?.isCompulsory == true ? "Compulsory" : "Optional"
        }}</span>
      </div>
    </div>
    <app-button
      [label]="'Edit Reward'"
      [className]="
        'text-[#081A46] w-full h-[50px] mt-[20px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] border border-[#081A46] bg-[#fff]'
      "
    />
  </div>
</app-side-modal>

